import { Site } from '@envato/foundation-types'
import { matchRoutes, RouteConfig } from 'react-router-config'
import { Store } from 'redux'

import { IPageComponent } from '../../../typings/pageComponent'
import { IMatchedRoute, PageType } from '../../../typings/routes'
import { IRootState } from '../../reducers'
import { getLocationParams, getSearchLocationParams } from './index'
import { ICommonLocation, IFlatQuery, IQuery } from './types'

interface IFetchAllRequests {
  store: Store<IRootState>
  location: ICommonLocation
  routes: RouteConfig[]
  apiUrlPrefix?: string
  apiAppUrlPrefix?: string
}

interface ICallBeforePageViewHandlers {
  store: Store<IRootState>
  location: ICommonLocation
  routes: RouteConfig[]
  prevLocation?: ICommonLocation
}

interface IGetMatchedRoute {
  currentSite: Site
  location: ICommonLocation
  routes: RouteConfig[]
}

export const fetchAllRequests = ({
  store,
  location,
  routes,
  apiUrlPrefix = '',
  apiAppUrlPrefix = ''
}: IFetchAllRequests) =>
  matchRoutes(routes, location.pathname).map(({ route, match }) => {
    const component = route.component as IPageComponent<any>
    return component && component.loadData
      ? component.loadData({
          store,
          location,
          apiUrlPrefix,
          apiAppUrlPrefix,
          routeMatch: match
        })
      : Promise.resolve({
          // resolve empty action
          type: 'noopAction'
        })
  })

export const callBeforePageViewHandlers = ({
  store,
  location,
  routes,
  prevLocation
}: ICallBeforePageViewHandlers) =>
  Promise.all(
    matchRoutes(routes, location.pathname).map(({ route, match }) => {
      const component = route.component as IPageComponent<any>
      if (component && component.onBeforePageView) {
        return component.onBeforePageView({
          store,
          location,
          routeMatch: match,
          prevLocation
        })
      }
    })
  )

export const getMatchedRoute = ({
  currentSite,
  location,
  routes
}: IGetMatchedRoute) => {
  const matchedRoutes = matchRoutes(routes, location.pathname) as IMatchedRoute<
    any
  >[]

  const pageLevelMatchedRouter = matchedRoutes[matchedRoutes.length - 1]
  const { route, match } = pageLevelMatchedRouter
  let params: IFlatQuery | IQuery

  if (
    route.pageType &&
    [PageType.SEARCH, PageType.CATEGORY].includes(route.pageType)
  ) {
    params = getSearchLocationParams({
      location,
      routeMatch: match,
      currentSite
    })
  } else {
    params = getLocationParams(location, match)
  }

  return {
    route,
    params
  }
}
